import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: 'https://keycloak.silabor.it',
  realm: 'silabor',
  clientId: 'labs',
});

export default keycloak;